import { render, staticRenderFns } from "./Videohub.vue?vue&type=template&id=8acd6e90&"
import script from "./Videohub.vue?vue&type=script&lang=js&"
export * from "./Videohub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports